import { useQuery } from "@tanstack/react-query";
import { ILogin } from "../interfaces";
import { login } from "../services";
import { AxiosError } from "axios";

export const useAuthentication = <T extends ILogin>({ id, password, enabled = false }: T & { enabled: boolean }) => {
  const {
    isLoading: loadingLoggingIn,
    isFetching: fetchingLogginIn,
    isError: errorLoggingIn,
    data: loginResponse,
    error: errorResponse,
    refetch,
  } = useQuery({
    queryKey: ["login"],
    queryFn: async () => await login({ id, password }),
    enabled: enabled || false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
  });
  const loginError = (errorResponse as AxiosError)?.response?.data;

  return { loadingLoggingIn, fetchingLogginIn, errorLoggingIn, loginResponse, loginError, refetch };
};
